export default "__VITE_ASSET__BkY_bui6__"